import React from "react";
import styled from "styled-components";
import { Spinner } from "react-bootstrap";

const StyledContactUsReceivedSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  flex-grow: 1;

  .header-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
    padding-top: 50px;
    padding-bottom: 30px;

    .header-title {
      margin-bottom: 32px;
      font-family: 'Arial';
      font-weight: bold;
      font-size: 42px;
      line-height: calc(1.42857rem * (42 / 16));
      text-transform: capitalize;
      text-align: center;
      color: #002346;
    }

    .header-text {
      margin-bottom: 32px;
      font-family: 'Arial';
      font-size: 16px;
      text-align: center;
    }
  }

  @media ${({ theme }) => theme.devices.laptopM} {
    .header-content {
      padding-top: 40px;
      padding-bottom: 20px;

      .header-title {
        margin-bottom: 28px;
        font-size: 36px;
        line-height: 62px;
      }

      .header-text {
        margin-bottom: 24px;
      }
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .header-content {
      .header-title {
        font-size: 32px;
        line-height: 58px;
      }
      .header-text {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .header-content {
      padding-left: 20px;
      padding-right: 20px;

      .header-title {
        margin-bottom: 20px;
        font-size: 24px;
        line-height: 33px;
      }

      .header-text {
        margin-bottom: 20px;
        font-size: 12px;
        line-height: 22px;
      }
    }
  }
`;

function ContactUsReceivedSection({ loading }) {
  return (
    <StyledContactUsReceivedSection>
      {loading && (
        <Spinner animation="border" variant="secondary" />
      )}
      {!loading && (
        <div className="header-content">
          <div className="header-title">
            <span>
              Thank you
            </span>
          </div>
          <div className="header-text">
            <span>
              Your request was received. You will hear from one of our experts within 1 business day.
            </span>
          </div>
        </div>
      )}
    </StyledContactUsReceivedSection>
  );
}

export default ContactUsReceivedSection;
